import CoreboundDialog from './CoreboundDialog';
import RelicIcon from './RelicIcon';
import { RELICS } from './relics';
import { BOSS_RELIC_NOTES } from './boss';
import { CORE_SECTOR } from './runConstants';
import './RelicDetailsDialog.css';

const RelicDetailsDialog = ({ relicId, game, onClose }) => {
  const relic = RELICS[relicId];
  if (!relic) return null;
  return (
    <CoreboundDialog
      title={relic.name}
      onClose={onClose}
      className="coreboundRelicDetails"
    >
      <RelicIcon relicId={relic.id} icon={relic.icon} />
      <span className={`coreboundRarity-${relic.category.toLowerCase()}`}>
        {relic.category} · OWNED
      </span>
      <p>
        {game.floor === CORE_SECTOR
          ? BOSS_RELIC_NOTES[relicId] || relic.description
          : relic.description}
      </p>
      {relicId === 'lastStandProtocol' && game.lastStandProtocol?.used && (
        <p role="status">Consumed · Survival attempt spent.</p>
      )}
      {relic.healOncePerRun && game.relicHealingUses?.[relicId] && (
        <p role="status">Used · Heal spent this run.</p>
      )}
    </CoreboundDialog>
  );
};
export default RelicDetailsDialog;
